module.exports = __webpack_public_path__ + "static/forbes-logo-svg@3x-44200fd1694a071b3e0f4c11fac28657.png";